<div>
  <ng-container *ngIf="withMainHeadline" class="mx-auto pt-[22px] px-[1.25rem] h-[calc(100%-100px)]">
    <nx-pageTitle-box class="mb-3" [label]="'Formulare'" [icon]="'icon-documents'" [iconToolTip]="'Formulare'"
    [bcRootLvlLabel]="'Einstellungen'"
    [bcRootLvlPath]="'settings'">
    </nx-pageTitle-box>
    <ng-container *ngTemplateOutlet="table"></ng-container>
  </ng-container>

  <ng-container *ngIf="!withMainHeadline">
    <ng-container *ngTemplateOutlet="table"></ng-container>
  </ng-container>
  <ng-template #table>
    <div class="body">
      <div class="flex flex-row bg-[#EAEEEF] h-12 rounded-t-md">
        <div class="basis-1/2 flex flex-row items-center ml-3 font-medium">
          Formulareliste
        </div>
        <div class="basis-1/2 flex flex-row justify-end items-center">
          <!-- <input pInputText type="text" class="p-inputtext p-component p-element mr-3"
            (input)="dtresources.filterGlobal($event.target?.['value'], 'contains')" placeholder="Ressource suchen" /> -->
        </div>
      </div>
        <div *ngFor="let form of forms">
          <div class="mt-[1.25rem]">
            <div class="flex flex-row bg-[#EAEEEF] h-12 rounded-t-md">
              <div class="basis-1/2 flex flex-row items-center ml-3 font-medium">
                <!-- <i [className]="'icon-documents'"></i> -->
                {{form?.name}}
              </div>
              <div class="basis-1/2 flex flex-row justify-end items-center">
                <app-nx-button (click)="createFormVariant(form?.key)" toolTip="neue Vorlage anlegen" icon="icon icon-plus">
                </app-nx-button>
              </div>
            </div>
            <div class="table_header p-5" *ngIf="form?.variants && form?.variants?.length > 0">
              <div  class="header w-1/4">Name</div>
              <div  class="header w-1/4">System</div>
              <div  class="header w-1/4">Aktiv</div>
              <div  class="header w-1/4"></div>
            </div>
            <div class="table_row flex flex-row basis-full pl-5 items-center" *ngFor="let variant of form?.variants" (click)="viewFormVariant(form?.key, variant.id)">
              <div  class="value w-1/4" >
                {{variant?.name? variant?.name: '-'}}
              </div>
              <div  class="value w-1/4">
                <p-checkbox [binary]="true" [ngModel]="variant.isSystem" [disabled]="true"></p-checkbox>
              </div>
              <div  class="value w-1/4" >
                <p-checkbox [binary]="true" [ngModel]="variant.isActive" [disabled]="true"></p-checkbox>
              </div>
              <div  class="delete w-1/4 flex justify-end">
                <app-nx-button toolTip="löschen" icon="icon icon-trash" (click)="$event.stopPropagation();variant?.isDeletable && confirmDialog(variant)" [disabled]="!variant.isDeletable"></app-nx-button>
              </div>
            </div>
            <div *ngIf="forms?.length === 0" class="no-data">
              <p>keine Forms vorhanden</p>
            </div>
          </div>
      </div>
    </div>
  </ng-template>
</div>
